import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { Button } from '../common';

export function PrintPdfButton(props: { request: IRequestGetOne }) {
    if (props.request.status === RequestStatus.draft || props.request.txcsProcesId) {
        return null;
    }

    if (
        props.request.service.serviceType !== ServiceType.referral &&
        props.request.service.serviceType !== ServiceType.referralSmall &&
        props.request.serviceType !== ServiceType.examination
    ) {
        return null;
    }

    return (
        <Button
            color="secondary"
            large
            onClick={async () => {
                const url = `/api/requests/${props.request.id}/downloadPdf`;
                window.open(url);
            }}
            outlined
        >
            {props.request.service.serviceType === ServiceType.referral ||
            props.request.service.serviceType === ServiceType.referralSmall
                ? translateKey('request.statusAction_printReferral')
                : translateKey('request.statusAction_printRequest')}
        </Button>
    );
}
